/**
 * Data-residency Phase 4: corporate reporting rows carry a `regionCode` string
 * ("US"/"CA"). The backend intentionally sends no display label for it (the code
 * set is tiny and fixed), so the front end owns the code->label mapping.
 */
export const REGION_CODE_LABELS: Readonly<Record<string, string>> = {
    US: 'United States',
    CA: 'Canada',
};

export function getRegionCodeLabel(code: string | null | undefined): string {
    if (!code) return '-';
    return REGION_CODE_LABELS[code] ?? code;
}
